import React from 'react';
import { CheckmarkIcon } from './Icons';
export const ProductIntroduction = () => {
  const features = ['Why your symptoms are likely a signal — not a malfunction of your body', 'The 3 quiet shifts that allow hormones to recalibrate: estrogen rhythm, metabolic flow, and nervous-system regulation', 'The Raw Carrot Practice — a simple, food-first daily habit quietly used by functional practitioners', 'Your gentle 30-Day Map — clear daily actions designed for women with real lives and full schedules', 'The 4 hidden patterns that keep your body in survival mode — and how to soften them with care', 'How to read your labs with new eyes — and what to ask for at your next appointment'];
  return <section className="w-full bg-white py-8 md:py-12 px-4 md:px-6" data-id="element-163">
      <div className="max-w-[780px] mx-auto text-center" data-id="element-164">
        <div className="font-lato font-bold text-[13px] text-medium tracking-[0.2em] mb-4" data-id="element-165">
          INTRODUCING
        </div>

        <h1 className="font-playfair text-[32px] md:text-[52px] text-primary mb-6" data-id="element-166">
          The Hormonal Balance Code
        </h1>

        <p className="font-lato text-[16px] md:text-[20px] text-secondary max-w-[680px] mx-auto mb-12" data-id="element-167">
          A calm, 30-day reset to help your body return to its natural rhythm —
          gently, intelligently, and without the overwhelm.
        </p>

        <div className="max-w-[680px] mx-auto text-left grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4" data-id="element-168">
          {features.map((feature, index) => <div key={index} className="group flex items-start gap-4 bg-light hover:bg-accent/40 transition-colors duration-300 rounded-[12px] p-5 border border-accent/60" data-id="element-169">
              <div className="flex-shrink-0 inline-flex items-center justify-center rounded-full" style={{
            width: '32px',
            height: '32px',
            background: '#957DAD',
            boxShadow: '0 4px 12px rgba(149,125,173,0.35)'
          }} aria-hidden="true" data-id="element-170">
                <CheckmarkIcon color="#FFFFFF" size={18} data-id="element-171" />
              </div>
              <p className="font-lato text-[15px] md:text-[16px] text-body leading-[1.6] m-0 flex-1" data-id="element-172">
                {feature}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
};